
import RendersBannerComponent from '@mixins/RendersBannerComponent';
import AssetSummary from '@components/AssetSummary.vue';
import TimeTravel from '@components/TimeTravel.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [RendersBannerComponent],

  computed: {
    ...mapGetters(['currentResource']),
  },

  components: {
    AssetSummary,
    TimeTravel,
  },
};
